import { render, staticRenderFns } from "./monitor-button.vue?vue&type=template&id=2b33d9c0&scoped=true&"
import script from "./monitor-button.vue?vue&type=script&lang=js&"
export * from "./monitor-button.vue?vue&type=script&lang=js&"
import style0 from "./monitor-button.vue?vue&type=style&index=0&id=2b33d9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33d9c0",
  null
  
)

export default component.exports